import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import number from "../../assets/icons/abhaNumberLogo.svg";
import at from "../../assets/icons/atLogo.svg";
// import mail from "../../assets/icons/mailLogo.svg";
import phone from "../../assets/icons/phoneLogo.svg";
import CreateAbhaNumber from "../../components/CreateAbhaNumber/CreateAbhaNumber";
import ProcessSuccess from "../../components/ProcessSuccess/ProcessSuccess";
import TermsAndConditionModal from "../../components/TermsAndConditionModal/TermsAndConditionModal";
import {
  ArrowIcon,
  BackArrowIcon,
  CircleWithTickIcon,
  InfoIcon
} from "../../front-end-global-components/assets/assets";
import arrow from "../../front-end-global-components/assets/DropDownArrow.svg";
import Button from "../../front-end-global-components/components/Button/Button";
import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import OTPInputBox from "../../front-end-global-components/components/OTPInputBox/OTPInputBox";
import {
  clearAbdmAuthCredentials,
  registerNewAbhaNumber,
  setAbdmTransactionId
} from "../../redux/abdm/actions";
import { switchLoginWithCustomToken } from "../../redux/authentication/actions";
import {
  clearLinkedProfiles,
  getModesForAbdmAuth,
  sendOtpForAbdmAuthentication,
  setAuthModes,
  setTransactionId,
  verifyAbdmAuthenticationOtp
} from "../../redux/patients/actions";
import { Regex } from "../../utils/regex";
import {
  isValidArray,
  isValidObject,
  validation
} from "../../utils/validators";
import { setErrorStatus } from "../../redux/status/actions";

function ABDMVerify(props) {
  const [authProcess, setAuthProcess] = useState("login");
  const [selectedAuthMethod, setSelectedAuthMethod] = useState(null);
  const [counter, setCounter] = useState(null);
  const [resendCount, setResendCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [identifier, setIdentifier] = useState({
    name: "Mobile Number",
    value: "phoneNumber",
    logo: phone,
    description: `${
      location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
    } VIA PHONE NO. CONNECTED WITH ABHA`
  });

  const [showConnectModal, setShowConnectModal] = useState({
    value: false,
    type: null
  });

  useEffect(() => {
    if (props.abdm.newHealthNumberData) {
      setIdentifier({
        name: "ABHA Number",
        value: "abhaNumber",
        logo: number,
        "data-cy": "AUTH-MODE-ABHA-NUMBER",
        description: `${
          location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
        } VIA ABHA NUMBER`
      });
    } else {
      setIdentifier({
        name: "Mobile Number",
        value: "phoneNumber",
        logo: phone,
        description: `${
          location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
        } VIA PHONE NO. CONNECTED WITH ABHA`
      });
    }
    // eslint-disable-next-line
  }, [authProcess, props.abdm.newHealthNumberData]);

  const [loginFormData, setLoginFormData] = useState({
    healthId:
      props.patients.currentProfile &&
      props.patients.profiles?.[props.patients.currentProfile]?.healthId
        ? props.patients.profiles?.[
            props.patients.currentProfile
          ]?.healthId?.replace("@sbx", "")
        : "",
    abhaNumber:
      props.abdm?.newHealthNumberData?.ABHAProfile?.ABHANumber?.split("-").join(
        ""
      ) || "",
    email: "",
    otp: "",
    agreeTo: false,
    aadhaarNumber: "",
    phoneNumber: props.auth.data?.phoneNumber
      ? props.auth.data?.phoneNumber
      : "+91",
    password: ""
  });

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    if (pathSegments.length >= 3) {
      setAuthProcess(pathSegments[2]);
    }
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    if (
      location.pathname.split("/").includes("login") &&
      props.patients.accessToken?.[props.patients.currentProfile]?.token
    ) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, [props.patients.accessToken]);

  useEffect(() => {
    if (showConnectModal.value) {
      setShowConnectModal({
        ...showConnectModal,
        value: false
      });
    }

    setTransactionId(null);
    clearLinkedProfiles(null);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isValidArray(props.patients.authModes)) {
      navigate("modes");
    } else {
      navigate("");
    }
    // eslint-disable-next-line
  }, [props.patients.authModes]);

  useEffect(() => {
    if (
      props.patients?.transaction?.id &&
      (identifier.value === "healthId" || identifier.value === "abhaNumber")
    ) {
      setShowConnectModal({
        ...showConnectModal,
        value: true
      });
    }
    // eslint-disable-next-line
  }, [props.patients?.transaction?.id]);

  const disableContinueButton = () => {
    const { agreeTo, healthId, abhaNumber, otp } = loginFormData;
    const { currentProfile, profiles, transaction } = props.patients;

    const isAadhaarLogin =
      authProcess === "login" && identifier.value === "aadhaarNumber";
    const profileNeedsConsent =
      currentProfile && !profiles[currentProfile]?.healthId;

    if (isAadhaarLogin && !agreeTo) {
      return true;
    }

    const identifierValid =
      (identifier?.value === "healthId" && healthId) ||
      (identifier?.value === "abhaNumber" && abhaNumber);

    if (!transaction?.id) {
      return !identifierValid;
    }

    const otpValid = otp?.length === 6;

    if (transaction?.id && otpValid) {
      return isAadhaarLogin && profileNeedsConsent ? !agreeTo : false;
    }

    return true;
  };

  useEffect(() => {
    if (counter === null || resendCount >= 2) {
      return;
    }

    if (counter <= 0) {
      setCounter(null);
      return;
    }

    const timer = setTimeout(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [counter, resendCount]);

  useEffect(() => {
    if (
      props.patients?.transaction?.id &&
      resendCount === 0 &&
      counter === null
    ) {
      setCounter(60);
    }
    // eslint-disable-next-line
  }, [props.patients?.transaction?.id]);

  const buttonDisableHandler = () => {
    const isAadhaarLogin =
      authProcess === "login" && identifier.value === "aadhaarNumber";
    const isHealthIdLogin =
      authProcess === "login" && identifier.value === "healthId";
    console.log(
      Regex.healthId?.test(loginFormData?.healthId),
      "Regex.healthId?.test(healthId)"
    );
    if (
      isHealthIdLogin &&
      Regex.healthId?.test(loginFormData?.healthId) === false
    ) {
      return true;
    }

    if (isAadhaarLogin && !loginFormData?.agreeTo) {
      return true;
    }
    if (counter && typeof counter === "number") {
      return true;
    }
    if (identifier.value === "healthId") {
      if (location.pathname.split("/").includes("login")) {
        return loginFormData[identifier.value].trim().length > 4 ? false : true;
      }
      Regex.healthId?.test(loginFormData[identifier.value]);
    } else {
      return !Regex[identifier.value].test(loginFormData[identifier.value]);
    }
  };

  const abdmAuthOnSubmitHandler = () => {
    const value = loginFormData?.[identifier.value];
    const transactionId = props.patients?.transaction?.id;

    const isIdentifier =
      (identifier.value === "healthId" || identifier.value === "abhaNumber") &&
      value;

    if (isIdentifier) {
      return getModesForAbdmAuth(
        authProcess,
        identifier.name,
        identifier.value === "healthId" ? `${value}@sbx` : value
      );
    }

    if (typeof transactionId === "string" && loginFormData.otp?.length === 6) {
      return verifyAbdmAuthenticationOtp(
        authProcess,
        identifier.name,
        loginFormData.otp,
        navigate,
        null,
        `${loginFormData.healthId?.trim()}@sbx`,
        loginFormData.phoneNumber || null
      );
    }

    return sendOtpForAbdmAuthentication(
      authProcess,
      selectedAuthMethod,
      identifier.name,
      identifier.value === "healthId" ? `${value}@sbx` : value
    );
  };

  return (
    <>
      <Header
        title={authProcess === "login" ? "ABDM Login" : "ABDM Register"}
        backButtonOnClick={() => {
          navigate("/");
          if (props.patients?.transaction?.id !== null) {
            setTransactionId(null);
            setAuthModes(null);
          }
        }}
        hideSupport={true}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />

      {!props.app.featureFlags.abhaService && (
        <FeatureFlagsFallback height="remaining-body-height max-width-588px" />
      )}

      {props.app.featureFlags.abhaService && (
        <section className="remaining-body-height max-width-588px margin-horizontal-auto overflow-y-auto inherit-parent-width ">
          <form
            className="inherit-parent-height flex-justify-content-space-between flex-direction-column"
            onChange={(event) => {
              if (event.target.name !== "agreeTo") {
                setLoginFormData({
                  ...loginFormData,
                  [event.target.name]: event.target.value
                });
              }
            }}
            onSubmit={(event) => {
              event.preventDefault();
              abdmAuthOnSubmitHandler();
            }}
          >
            <section>
              <AuthModeSwitcher
                // disable={
                //   props.patients.profiles?.[props.patients.currentProfile]
                //     ?.healthId && location.pathname.includes("login")
                // }
                data={identifier}
                downArrowOnClick={() => {
                  navigate(`/abdm/${authProcess}/authSwitch`);
                }}
              />

              <div className="padding-right-larger padding-left-larger">
                {(identifier.value === "phoneNumber" ||
                  identifier.value === "aadhaarNumber") && (
                  <>
                    <InputBox
                      className="inherit-parent-width border-radius-default margin-bottom-default"
                      name={
                        identifier.value === "phoneNumber"
                          ? "phoneNumber"
                          : "aadhaarNumber"
                      }
                      label={
                        identifier.value === "phoneNumber"
                          ? "Phone Number"
                          : "Aadhaar Number"
                      }
                      type={
                        identifier.value === "phoneNumber" ? "tel" : "password"
                      }
                      autoFocus={true}
                      value={
                        identifier.value === "phoneNumber"
                          ? loginFormData.phoneNumber
                          : loginFormData.aadhaarNumber
                      }
                      data-cy={`ABHA-LOGIN-${
                        identifier.value === "phoneNumber"
                          ? "PHONE-NUMBER"
                          : "AADHAAR-NUMBER"
                      }-FIELD`}
                      validation={(value) =>
                        validation(
                          identifier.value === "phoneNumber"
                            ? "phoneNumber"
                            : "aadhaarNumber",
                          value
                        )
                      }
                      required
                    />

                    {typeof props.patients?.transaction?.id === "string" && (
                      <>
                        <OTPInputBox
                          name="otp"
                          autoFocus={true}
                          value={loginFormData.otp}
                          setValue={(otpValue) => {
                            setLoginFormData({
                              ...loginFormData,
                              otp: otpValue
                            });
                          }}
                          required
                          className="margin-bottom-larger"
                        />

                        <div className="display-flex flex-justify-content-space-between font-size-medium margin-bottom-larger">
                          {counter &&
                          typeof counter === "number" &&
                          resendCount <= 1 ? (
                            <div>
                              {`00:${counter
                                .toString()
                                .padStart(2, "0")} seconds`}
                            </div>
                          ) : (
                            <div />
                          )}

                          <div
                            className={`${
                              typeof counter === "number" && counter > 0
                                ? "font-color-tertiary"
                                : "font-color-primary"
                            }`}
                            onClick={() => {
                              const isTimerActive =
                                typeof counter === "number" &&
                                counter > 0 &&
                                resendCount <= 1;

                              // Disable only while timer is running
                              if (isTimerActive) {
                                return;
                              }

                              // Limit after 2 resends
                              if (resendCount >= 2) {
                                return setErrorStatus({
                                  code: "custom",
                                  message:
                                    "OTP Resend limit reached. Try after 30 minutes."
                                });
                              }

                              const value = loginFormData?.[identifier.value];

                              sendOtpForAbdmAuthentication(
                                authProcess,
                                selectedAuthMethod,
                                identifier.name,
                                identifier.value === "healthId"
                                  ? `${value}@sbx`
                                  : value
                              );

                              // First resend -> show timer
                              const nextCount = resendCount + 1;

                              setResendCount(nextCount);

                              // Only first resend should start timer
                              if (nextCount === 1) {
                                setCounter(60);
                              } else {
                                // second resend onwards
                                setCounter(null);
                              }
                            }}
                          >
                            Resend OTP
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {identifier.name === "ABHA Address" && (
                  <InputBox
                    labelClassName="letter-spacing-4-percentage"
                    className="inherit-parent-width border-radius-default margin-bottom-default"
                    label="ABHA Address"
                    type="text"
                    name="healthId"
                    autoFocus={true}
                    value={loginFormData.healthId}
                    inputSuffixPlaceHolder={"@sbx"}
                    // disabled={
                    //   props.patients.currentProfile &&
                    //   props.patients.profiles[props.patients.currentProfile]
                    //     ?.healthId
                    //     ? true
                    //     : false
                    // }

                    validation={(value) => {
                      if (value.length < 8 || value.length > 18) {
                        return {
                          status: false,
                          message:
                            "ABHA Address must be between 8 and 18 characters long."
                        };
                      } else if (value.includes("@sbx")) {
                        return {
                          status: false,
                          message: "@sbx is not needed"
                        };
                      } else if (Regex.healthId?.test(value) === false) {
                        return {
                          status: false,
                          message:
                            "ABHA Address must start with a letter and may contain only one dot or underscore in between."
                        };
                      } else {
                        return {
                          status: true
                        };
                      }
                    }}
                    inputNotesClassName="font-color-primary font-size-smaller padding-top-small"
                    data-cy="HEALTH-ID-INPUT-BOX"
                  />
                )}

                {identifier.name === "ABHA Number" && (
                  <>
                    <InputBox
                      className="inherit-parent-width border-radius-default margin-bottom-default"
                      name="abhaNumber"
                      label="ABHA Number"
                      type="text"
                      autoFocus={true}
                      value={[loginFormData.abhaNumber]}
                      required
                      disabled={props.patients.loading}
                      data-cy="ABHA-NUMBER-INPUT-BOX"
                    />

                    <div
                      className=" font-size-small font-color-primary text-align-right"
                      onClick={() => {
                        navigate("/abdm/register/createAbhaNumber");
                        if (typeof props.abdm.transactionId === "string") {
                          setAbdmTransactionId(null);
                        }
                      }}
                    >
                      Create ABHA Number
                    </div>
                  </>
                )}
              </div>
              {props.auth.data.phoneNumber !== loginFormData.phoneNumber &&
                loginFormData.phoneNumber.length === 13 && (
                  <div className="display-flex padding-left-larger flex-align-items-center">
                    <InfoIcon />
                    <div className="padding-left-default font-size-smaller padding-right-larger">
                      The Phone number entered is different from the number used
                      to login. You can access this ABHA Address by switching to
                      the respective phone number on Ninto
                    </div>
                  </div>
                )}
            </section>
            <section className="padding-left-larger padding-right-larger">
              {authProcess === "login" &&
                identifier.value === "aadhaarNumber" &&
                !props.patients?.transaction?.id && (
                  <div className="inherit-parent-width display-flex padding-top-large text-align-left margin-bottom-large flex-align-items-center">
                    <CheckBox
                      name="agreeTo"
                      label={
                        <div className="font-size-small">
                          I agree to voluntarily share my identity information
                          with Ninto to create my ABHA Address
                          {
                            <span
                              className="cursor-pointer font-family-RHD-regular padding-left-small font-color-primary"
                              onClick={() => {
                                navigate(`/abdm/${authProcess}/terms`);
                              }}
                            >
                              User Information Agreement
                            </span>
                          }
                        </div>
                      }
                      checked={loginFormData.agreeTo}
                      onChange={() => {
                        setLoginFormData({
                          ...loginFormData,
                          agreeTo: loginFormData.agreeTo ? false : true
                        });
                      }}
                      data-cy="TERMS-CHECKBOX"
                    />
                  </div>
                )}

              <Button
                text={props.patients?.transaction?.id ? "Submit" : "Continue"}
                data-cy="ABDM-LOGIN-BUTTON"
                boxShadow={false}
                required
                type="submit"
                disabled={
                  props.patients?.transaction?.id
                    ? disableContinueButton()
                    : buttonDisableHandler()
                }
                loading={props.patients.loading}
              />
              <AuthSwitcher
                authMode={location.pathname.includes("login")}
                onClick={() => {
                  if (
                    typeof props.abdm?.auth?.otp?.requestMethod === "string"
                  ) {
                    clearAbdmAuthCredentials();
                  }
                  setTransactionId(null);
                  setCounter(null);
                  setAuthModes(null);
                  if (location.pathname.includes("login")) {
                    navigate("/abdm/register");
                  } else {
                    navigate("/abdm/login");
                  }
                }}
              />
            </section>
          </form>
          {props.patients.isMultipleLogin &&
            isValidArray(props.patients?.linkedProfiles) &&
            props.patients?.linkedProfiles.some(
              (data) => typeof data.customToken === "string"
            ) && (
              <ProcessSuccess
                title="ABHA Address Logged in Successfully"
                description={`YOUR ABHA ADDRESS IS ${loginFormData?.healthId}@sbx`}
                confirmClick={() => {
                  if (
                    isValidArray(props.patients?.linkedProfiles) &&
                    isValidObject(
                      props.patients?.linkedProfiles?.find(
                        (ele) => ele.customToken
                      )
                    )
                  ) {
                    navigate("/linkedProfiles");
                  } else {
                    props.confirmOnclick();
                  }
                }}
              />
            )}

          {/* Modal for login types */}
        </section>
      )}

      <Routes>
        <Route
          path="/createAbhaNumber/*"
          element={
            <CreateAbhaNumber
              auth={props.auth}
              transactionId={props.abdm.transactionId}
              accessToken={props.auth.data.accessToken}
              abhaNumberDetails={props.abdm.newHealthNumberData}
              isHealthIdExists={props.abdm.healthIdExists}
              loading={props.abdm.loading}
              closeModal={() => {
                setAuthModes(null);
                navigate("/abdm/register/");
                if (props.abdm.newHealthNumberData) {
                  registerNewAbhaNumber({
                    clearNewHealthNumberData: true
                  });
                }
              }}
            />
          }
        />
        <Route
          path="/modes"
          element={
            <LoginModesModal
              transactionId={props.patients.transaction?.id}
              authModes={props.patients.authModes}
              selectedAuthMethod={selectedAuthMethod}
              setSelectedAuthMethod={setSelectedAuthMethod}
              authProcess={authProcess}
              setShowConnectModal={setShowConnectModal}
              identifier={identifier}
              loginFormData={loginFormData}
              loading={props.patients.loading}
            />
          }
        />
        <Route
          path="/authSwitch"
          element={
            <AuthModeModal
              identifier={identifier}
              setIdentifier={setIdentifier}
              setSelectedAuthMethod={setSelectedAuthMethod}
              authProcess={authProcess}
            />
          }
        />
        <Route
          path="/linkedProfiles"
          element={
            <LinkedProfilesModal linkedProfiles={props.patients.linkedProfiles} />
          }
        />
        <Route
          path="confirm"
          element={
            <ConfirmModal
              showConnectModal={showConnectModal}
              setShowConnectModal={setShowConnectModal}
              authProcess={authProcess}
              identifier={identifier}
              loginFormData={loginFormData}
              setLoginFormData={setLoginFormData}
              counter={counter}
              setCounter={setCounter}
              patients={props.patients}
              selectedAuthMethod={selectedAuthMethod}
            />
          }
        />
        <Route
          path="terms"
          element={
            <TermsAndConditionModal
              onClose={() => {
                navigate(`/abdm/${authProcess}`);
              }}
              isAadhaarTerms={
                location.pathname.split("/").includes("login") ? true : false
              }
            />
          }
        />
      </Routes>

      <Outlet />
    </>
  );
}

const mapStateToProps = (state) => ({
  abdm: state.abdm,
  auth: state.auth,
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(ABDMVerify);

const AuthSwitcher = (props) => {
  return (
    <div
      className="cursor-pointer font-size-small text-align-center margin-top-large padding-bottom-large"
      onClick={() => {
        props.onClick();
      }}
    >
      <span className="font-family-gilroy-regular font-color-secondary padding-right-smaller">
        {props.authMode
          ? "Don’t have a ABHA address?"
          : "Already have a ABHA address? "}
      </span>
      <span className="font-family-gilroy-medium font-color-primary">
        {props.authMode ? "Register" : "Login"}
      </span>
    </div>
  );
};

const AuthModeSwitcher = (props) => {
  return (
    <div
      className="inherit-parent-width padding-top-large margin-bottom-larger display-flex flex-justify-content-space-between flex-center-children-vertically border-bottom-1px-e5e5e5"
      data-cy="ABDM-AUTH-SWITCHER"
      onClick={props.disable ? () => {} : props.downArrowOnClick}
    >
      <div
        data-cy={`LOGIN-AUTH-MODE-${props.data.value.toUpperCase()}`}
        className="padding-left-large padding-right-default display-flex flex-direction-row"
      >
        <img className="padding-right-default" src={props.data.logo} alt="" />
        <div className="inherit-parent-width padding-default">
          <div className="font-family-gilroy-regular padding-bottom-smaller">
            {props.data.name}
          </div>
          <div className="font-size-smaller">{props.data.description}</div>
        </div>
      </div>
      {!props.disable && (
        <div className="padding-right-large">
          <img src={arrow} alt="arrow" />
        </div>
      )}
    </div>
  );
};

function LinkedProfilesModal(props) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const navigate = useNavigate();

  return (
    <Modal
      show={true}
      onClose={() => {
        navigate("/abdm/login");
      }}
      canIgnore={false}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div className="background-white padding-larger font-family-gilroy-medium user-select-none">
        <div className="inherit-parent-width inherit-parent-height">
          {typeof selectedIndex !== "number" && (
            <>
              <div className="text-align-center font-size-small padding-medium font-color-secondary">
                SELECT TO VIEW CONNECTED HEALTH ID
              </div>
              {props.linkedProfiles?.map((data, index) => (
                <div
                  onClick={() => {
                    setSelectedIndex(index);
                  }}
                  className="display-flex flex-justify-content-space-between padding-bottom-default"
                  key={index}
                >
                  <div>{data.phoneNumber}</div>
                  <ArrowIcon />
                </div>
              ))}

              <div>
                <div className="flex-center-children-vertically margin-vertical-large ">
                  <hr
                    style={{ width: "100%" }}
                    className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
                  />
                  <span className=" margin-horizontal-default display-inline-block font-color-tertiary font-size-small">
                    OR
                  </span>
                  <hr
                    style={{ width: "100%" }}
                    className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
                  />
                </div>
              </div>
              <div>
                <div className="font-size-small text-align-center">
                  Create health ID with same number?
                  <span className="font-color-primary padding-left-small">
                    Click here{" "}
                  </span>{" "}
                </div>
              </div>
            </>
          )}
          {typeof selectedIndex === "number" && (
            <>
              <div className="text-align-center font-size-small padding-medium font-color-secondary">
                CONNECTED HEALTH ID
              </div>
              <div className="text-align-center font-size-small font-color-secondary">
                You will now logout from registered phone number then login to
                this number to access the shown health id(s)
              </div>

              <div className="padding-top-large">
                {props.linkedProfiles?.[selectedIndex]?.phoneNumber}
              </div>

              <div
                style={{
                  height: "100px"
                }}
                className="flex-direction-row gap-0-point-5em margin-top-small flex-wrap overflow-auto padding-top-large padding-bottom-default padding-right-medium"
              >
                {props.linkedProfiles?.[selectedIndex]?.linkedAbhaAddress.map(
                  (chip, index) => (
                    <div
                      className={`font-size-small text-overflow-ellipsis padding-small border-2px-lite-grey border-radius-default font-size-small font-family-gilroy-regular font-color-secondary`}
                      key={index}
                    >
                      <span>{chip}</span>
                    </div>
                  )
                )}
              </div>

              <section className="display-flex padding-top-larger ">
                <Button
                  boxShadow={false}
                  type="button"
                  text="Continue"
                  className={"border-1px-e5e5e5 margin-right-small"}
                  onClick={() => {
                    switchLoginWithCustomToken(
                      {
                        customToken:
                          props.linkedProfiles?.[selectedIndex]?.customToken
                      },
                      navigate
                    );
                  }}
                  data-cy="CONFIRM-LOGOUT-BUTTON"
                />
                <Button
                  boxShadow={false}
                  text="Back"
                  variant={"secondary"}
                  onClick={() => {
                    setSelectedIndex(null);
                  }}
                  className={
                    "font-color-secondary border-1px-e5e5e5 margin-left-small"
                  }
                  data-cy="CANCEL-LOGOUT-BUTTON"
                />
              </section>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}

const AuthModeModal = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const Identifiers = {
    phone: {
      name: "Mobile Number",
      value: "phoneNumber",
      logo: phone,
      "data-cy": "AUTH-MODE-PHONE-NUMBER",
      description: `${
        location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
      } VIA PHONE NO. CONNECTED WITH ABHA`
    },
    abhaAddress: {
      name: "ABHA Address",
      value: "healthId",
      logo: at,
      "data-cy": "AUTH-MODE-HEALTH-ID",
      description: `${
        location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
      } VIA ABHA ADDRESS CONNECTED WITH YOUR PROFILE`
    },
    abhaNumber: {
      name: "ABHA Number",
      value: "abhaNumber",
      logo: number,
      "data-cy": "AUTH-MODE-ABHA-NUMBER",
      description: `${
        location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
      } VIA ABHA NUMBER`
    },
    aadhaarNumber: {
      name: "AADHAAR Number",
      value: "aadhaarNumber",
      logo: number,
      "data-cy": "AUTH-MODE-AADHAAR-NUMBER",
      description: `${
        location.pathname.split("/").includes("login") ? "LOGIN" : "REGISTER"
      } VIA AADHAAR NUMBER`
    }
    // ,
    // mail: {
    //   name: "Email",
    //   value: "email",
    //   logo: mail,
    //   "data-cy": "AUTH-MODE-EMAIL",
    //   description: `${
    //     location.pathname.split("/").includes("login")
    //       ? "LOGIN"
    //       : "REGISTER"
    //   } VIA MAIL ${
    //     location.pathname.split("/").includes("login")
    //       ? "ID CONNECTED WITH ABHA"
    //       : "ID"
    //   }`
    // }
  };

  return (
    <Modal
      show={true}
      onClose={() => {
        navigate(`/abdm/${props.authProcess}`);
        setTransactionId(null);
        setAuthModes(null);
      }}
      canIgnore
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div
        className="inherit-parent-width inherit-parent-height "
        style={{ flexBasis: "1" }}
      />
      <footer
        data-cy="ABDM-AUTH-SWITCHER-MODAL"
        className="inherit-parent-width background-white"
      >
        <div className="padding-larger">
          <div className="text-align-center padding-bottom-default font-size-smaller">
            {`SELECT TO ${
              location.pathname.includes("login") ? "LOGIN" : "REGISTER"
            } WITH YOUR ABHA ADDRESS`}
          </div>
          {Object.values(Identifiers).map(
            (data, index) =>
              (location.pathname.includes("login") ||
                (location.pathname.includes("register") &&
                  data.value !== "healthId" &&
                  data.value !== "aadhaarNumber")) && (
                <div
                  key={index}
                  className={`inherit-parent-width display-flex flex-justify-content-space-between flex-center-children-vertically ${
                    index === 0 ? "" : "padding-top-large"
                  }`}
                  data-cy={`LOGIN-MODE-${data.value.toUpperCase()}`}
                  onClick={() => {
                    props.setIdentifier(data);
                    props.setSelectedAuthMethod(data.name);
                    navigate(-1);
                    setTransactionId(null);
                  }}
                >
                  <div className="display-flex flex-direction-row">
                    <img
                      className="padding-right-default"
                      src={data.logo}
                      alt=""
                    />
                    <div className="inherit-parent-width padding-default">
                      <div className="font-family-gilroy-regular padding-bottom-smaller">
                        {data.name}
                      </div>
                      <div className="font-size-smaller">
                        {data.description}
                      </div>
                    </div>
                  </div>
                  {props.identifier.name === data.name ? (
                    <CircleWithTickIcon
                      circleColor={"white"}
                      circleOutline={"#00a000"}
                      tickColor={"#00a000"}
                    />
                  ) : (
                    <div className="rotate-90">
                      <img src={arrow} alt="arrow" />
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      </footer>
    </Modal>
  );
};

const LoginModesModal = (props) => {
  const navigate = useNavigate();

  const [authModes, setAuthModes] = useState(null);

  useEffect(() => {
    if (props.selectedAuthMethod === "ABHA Address") {
      setAuthModes(props.authModes.filter((d) => d !== "AADHAAR_OTP"));
    } else {
      setAuthModes(props.authModes);
    }
    // eslint-disable-next-line
  }, [props.authModes]);

  useEffect(() => {
    if (!isValidArray(props.authModes)) {
      navigate(`abdm/${props.authProcess}`);
    }
    // eslint-disable-next-line
  }, [props.authModes, props.authProcess]);

  useEffect(() => {
    if (typeof props.transactionId === "string") {
      navigate(`/abdm/${props.authProcess}/confirm`);
    }
    // eslint-disable-next-line
  }, [props.transactionId]);

  return (
    <Modal
      show={true}
      onClose={() => {
        navigate(`/abdm/${props.authProcess}`);
        setTransactionId(null);
        setAuthModes(null);
      }}
      canIgnore
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div
        className="inherit-parent-width inherit-parent-height "
        style={{ flexBasis: "1" }}
      />
      <footer
        data-cy="LOGIN-MODE-SELECT-MODAL"
        className="inherit-parent-width background-white"
      >
        <div className="padding-larger">
          <div className="text-align-center padding-bottom-default font-size-smaller">
            CHOOSE HOW YOU WANT TO LOGIN
          </div>

          {Object.values(authMethods).map(
            (data, index) =>
              authModes?.includes(data.value) && (
                <div
                  key={index}
                  data-cy={`LOGIN-MODE-${data["data-cy"]}`}
                  className={`inherit-parent-width display-flex flex-justify-content-space-between flex-center-children-vertically ${
                    index === 0 ? "" : "padding-top-large"
                  }`}
                  onClick={() => {
                    props.setSelectedAuthMethod(data.name);
                    props.setShowConnectModal({
                      value: false,
                      type: data.name
                    });
                    if (data.value === "PASSWORD") {
                      navigate(`/abdm/${props.authProcess}/confirm`);
                    } else if (!props.loading) {
                      sendOtpForAbdmAuthentication(
                        props.authProcess,
                        data.name,
                        props.identifier.name,
                        props.identifier.value === "healthId"
                          ? `${
                              props.loginFormData?.[props.identifier.value]
                            }@sbx`
                          : props.loginFormData?.[props.identifier.value]
                      );
                    }
                  }}
                >
                  <div className="display-flex flex-direction-row">
                    <div className="inherit-parent-width padding-default">
                      <div className="font-family-gilroy-regular padding-bottom-smaller">
                        {data.name}
                      </div>
                      <div className="font-size-smaller">
                        {data.description}
                      </div>
                    </div>
                  </div>
                  {props.loading && props.selectedAuthMethod === data.name ? (
                    <div
                      className="loading-spinner"
                      data-cy="LOADING-SPINNER"
                    />
                  ) : (
                    <div className="rotate-90">
                      <img src={arrow} alt="arrow" />
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      </footer>
    </Modal>
  );
};

const ConfirmModal = (props) => {
  const [resendCount, setResendCount] = useState(0);
  const navigate = useNavigate();

  return (
    <Modal
      show={true}
      onClose={() => {
        navigate(`/abdm/${props.authProcess}`);
        setTransactionId(null);
        setAuthModes(null);
      }}
      canIgnore={false}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div
        className="inherit-parent-width inherit-parent-height "
        style={{ flexBasis: "1" }}
      />
      <footer className="inherit-parent-width background-white">
        <div className="padding-larger">
          <div className="flex-justify-content-space-between">
            <div
              onClick={() => {
                navigate(`/abdm/${props.authProcess}`);
                setTransactionId(null);
                setAuthModes(null);
              }}
            >
              <BackArrowIcon />
            </div>
            <div className="text-align-center padding-bottom-default font-size-smaller">
              {props.showConnectModal.type === "Password"
                ? "ENTER YOUR PASSWORD"
                : "ENTER YOUR OTP"}
            </div>
            <div />
          </div>

          <form
            onSubmit={(event) => {
              event.preventDefault();
              verifyAbdmAuthenticationOtp(
                props.authProcess,
                props.identifier.name,
                props.loginFormData.otp
                  ? props.loginFormData.otp
                  : props.loginFormData.password,
                navigate,
                props.loginFormData.password ? true : false,
                `${props.loginFormData.healthId?.trim()}@sbx`,
                null,
                props.selectedAuthMethod
              );
            }}
          >
            {props.showConnectModal.type === "Password" && (
              <InputBox
                className="inherit-parent-width border-radius-default margin-bottom-default"
                name="password"
                label="Password"
                type="password"
                otpFocus={true}
                autoFocus={true}
                value={props.loginFormData.password}
                onChange={(event) => {
                  props.setLoginFormData({
                    ...props.loginFormData,
                    password: event.target.value
                  });
                }}
                required
                disabled={props.patients.loading}
                data-cy="PASSWORD-INPUT-BOX"
              />
            )}
            {["Mobile", "Aadhaar", "Email"].includes(
              props.showConnectModal.type
            ) && (
              <>
                <OTPInputBox
                  name="otp"
                  autoFocus={true}
                  removeDefaultLabel={true}
                  value={props.loginFormData.otp}
                  setValue={(otpValue) => {
                    props.setLoginFormData({
                      ...props.loginFormData,
                      otp: otpValue
                    });
                  }}
                  required
                  className="margin-bottom-large"
                />
                <div className="display-flex flex-justify-content-space-between font-size-medium margin-bottom-larger">
                  {props.counter &&
                  typeof props.counter === "number" &&
                  resendCount <= 1 ? (
                    <div>
                      {`00:${props.counter
                        .toString()
                        .padStart(2, "0")} seconds`}
                    </div>
                  ) : (
                    <div />
                  )}
                  {console.log(resendCount, "resendCount")}
                  <div
                    className={`${
                      typeof props.counter === "number" &&
                      props.counter > 0 &&
                      resendCount <= 1
                        ? "font-color-tertiary"
                        : "font-color-primary"
                    }`}
                    onClick={() => {
                      const isTimerActive =
                        typeof props.counter === "number" &&
                        props.counter > 0 &&
                        resendCount <= 1;

                      // Disable only while timer is running
                      if (isTimerActive) {
                        return;
                      }

                      // 2. Throw error after 2 attempts
                      if (resendCount >= 2) {
                        return setErrorStatus({
                          code: "custom",
                          message:
                            "OTP Resend limit reached. Try after 30 minutes."
                        });
                      }

                      sendOtpForAbdmAuthentication(
                        props.authProcess,
                        props.selectedAuthMethod,
                        props.identifier.name,
                        props.identifier.value === "healthId"
                          ? `${
                              props.loginFormData?.[props.identifier.value]
                            }@sbx`
                          : props.loginFormData?.[props.identifier.value]
                      );

                      // First resend -> show timer

                      const nextCount = resendCount + 1;

                      setResendCount(nextCount);

                      // Only first resend should start timer
                      if (nextCount === 1) {
                        props.setCounter(60);
                      } else {
                        // second resend onwards
                        props.setCounter(null);
                      }
                    }}
                  >
                    Resend OTP
                  </div>
                </div>
              </>
            )}

            <Button
              text={props.authProcess === "register" ? "Create" : "Login"}
              data-cy="ABHA-LOGIN-BUTTON"
              boxShadow={false}
              required
              type="submit"
              disabled={
                !(
                  props.loginFormData.password ||
                  (props.loginFormData.otp.length === 6 &&
                    props.patients?.transaction?.id)
                )
              }
              loading={props.patients.loading}
            />
          </form>
        </div>
      </footer>
    </Modal>
  );
};

const authMethods = {
  phone: {
    name: "Mobile",
    value: "MOBILE_OTP",
    "data-cy": "AUTH-TYPE-MOBILE",
    description: "OTP will be sent to your registered Mobile number"
  },
  password: {
    name: "Password",
    value: "PASSWORD",
    "data-cy": "AUTH-TYPE-PASSWORD",
    description: "Use the password linked to the provided ABHA address"
  },
  aadhaar: {
    name: "Aadhaar",
    value: "AADHAAR_OTP",
    "data-cy": "AUTH-TYPE-AADHAAR",
    description: "OTP will be sent to your registered Aadhaar number"
  },
  email: {
    name: "Email",
    value: "EMAIL_OTP",
    "data-cy": "AUTH-TYPE-EMAIL",
    description: "OTP will be sent to your registered Email ID"
  }
};
